'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserDocument } from '../../Entities/User/UserDocument';
import { UserDocumentCollection } from '../../Collections/User/UserDocumentCollection';

export class UserDocumentRepository extends CoreRepository {
  public getUserDocuments(
    userId: number,
    type: string,
    options: object = {},
    criteria: object = null
  ) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserDocuments(userId, type, options).then((response) => {
      const collection = new UserDocumentCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserDocument();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getUserDocumentBySystemName(
    userId: number,
    docSystemName: string,
    options: object = {},
    criteria: object = null
  ) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI
      .getUserDocumentBySystemName(userId, docSystemName, options)
      .then((response) => {
        return response;
      });
  }

  public moveIndDocuments(userId: number, individualId: number, payload: any[]) {
    return this.webAPI.moveIndDocuments(userId, individualId, payload).then((response) => {
      return response;
    });
  }
}
